import React, { FC } from 'react';
import { StyledDiv, CounterWrapper } from './styles';
import { ReactComponent as LeftIcon } from 'applicaiton/assets/left.svg';
import { ReactComponent as RightIcon } from 'applicaiton/assets/right.svg';
import { useTranslation } from 'react-i18next';

interface CounterProps {
  value: number;
  handleSetQuantity: (value: number) => void;
  id: string;
}

const Counter: FC<CounterProps> = ({ value, id, handleSetQuantity }) => {
  const { t } = useTranslation();
  return (
    <StyledDiv>
      <div>
        <p>{t('number_of_doctors')}</p>
      </div>
      <CounterWrapper active={false}>
        <button
          onClick={(event) => {
            event.stopPropagation();
            handleSetQuantity(value - 1);
          }}
          disabled={!value}
        >
          <LeftIcon />
        </button>
        <input
          id={id}
          type="number"
          value={value}
          onChange={(e) => handleSetQuantity(Number(e.target.value))}
          onWheel={(e) => e.currentTarget.blur()}
        />
        <button
          onClick={(event) => {
            event.stopPropagation();
            handleSetQuantity(value + 1);
          }}
        >
          <RightIcon />
        </button>
      </CounterWrapper>
    </StyledDiv>
  );
};

export default Counter;
